module.exports = __webpack_public_path__ + "img/icon-rust.53be624f.svg";